import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './main/main.component';
import { ReceiptsComponent } from './documents/receipts/receipts.component';
import { PrintersComponent } from './administration/printers/printer.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { HomeComponent } from './home/home.component';
import { AuthComponent } from './auth/auth.component';
import { SalesStatementComponent } from './reports/sales-statement/sales-statement.component';
import { ForbiddenComponent } from './auth/forbidden/forbidden.component';
import { QueueStatusComponent } from './reports/queue-status/queue-status.component';
import { PrintersStatusComponent } from './reports/printers-status/printers-status.component';
import { ReportIssueComponent } from './report-issue/report-issue.component';
import { DailyReportsComponent } from './documents/daily-reports/daily-reports.component';
import { NonFiscalsComponent } from './documents/non-fiscals/non-fiscals.component';
import { AuthGuard } from './auth/auth.guard';
import { UserComponent } from './administration/users/user.component';
import { ShopComponent } from './administration/shops/shop.component';
import { RoleEnum } from './administration/users/user-role.enum';
import { PermissionEnum } from './administration/users/user-permission.enum';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'sign-in',
        data: { isFromRedirect: false },
        component: SignInComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      }
    ],
  },
  {
    path: '',
    //canActivate: [AuthGuard],
    component: MainComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'documents',
        children: [
          {
            path: 'receipts',
            canActivate: [AuthGuard],
            data: { requiredPermission: PermissionEnum.Receipts },
            component: ReceiptsComponent,
          },
          {
            path: 'daily-reports',
            canActivate: [AuthGuard],
            data: { requiredPermission: PermissionEnum.DailyReports },
            component: DailyReportsComponent,
          },
          {
            path: 'non-fiscals',
            canActivate: [AuthGuard],
            data: { requiredPermission: PermissionEnum.NonFiscals },
            component: NonFiscalsComponent,
          }
        ]
      },
      {
        path: 'reports',
        children: [
          {
            path: 'sales-statement',
            canActivate: [AuthGuard],
            data: { requiredPermission: PermissionEnum.SalesStatement },
            component: SalesStatementComponent,
          },
          {
            path: 'printers-status',
            canActivate: [AuthGuard],
            data: { requiredPermission: PermissionEnum.PrinterStatus },
            component: PrintersStatusComponent,
          },
          {
            path: 'queue-status',
            canActivate: [AuthGuard],
            data: { requiredPermission: PermissionEnum.QueueStatus },
            component: QueueStatusComponent,
          }
        ]
      },
      {
        path: 'administration',
        children: [
          {
            path: 'printers',
            canActivate: [AuthGuard],
            data: { requiredPermission: PermissionEnum.Printers },
            component: PrintersComponent,
          },
          {
            path: 'shops',
            canActivate: [AuthGuard],
            data: { requiredPermission: PermissionEnum.Shops },
            component: ShopComponent,
          },
          {
            path: 'users',
            canActivate: [AuthGuard],
            data: { role: RoleEnum.Administrator },
            component: UserComponent
          }
        ]
      },
      {
        path: 'forbidden',
        component: ForbiddenComponent
      },
      {
        path: 'report-issue',
        canActivate: [AuthGuard],
        component: ReportIssueComponent
      },
    ]
  },
  {
    path: 'access-denied',
    component: ForbiddenComponent
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
